import React from 'react';
import { s } from "../../Style.jsx";

const TagBrowser = ({ tags, setSelectedTag }) => {

    let sortedTags = [...(tags || [])].sort((a, b) => a.localeCompare(b));

    return <>

        <h3 style={s.title3}>Tags</h3>

        <div style={s.box}>

            <div style={s.table}>

                {(sortedTags || []).map((tag, i) => <span key={i} onClick={() => setSelectedTag(tag)} style={s.cell(i)}>
                    <span style={s.input}>{tag}</span>
                </span>)}

            </div>
        </div>

    </>;

}

export default TagBrowser;